import { Component, OnDestroy, OnInit } from '@angular/core';
import { WidgetsService } from '../../shared/services/widgets.service';
import { requestPayload } from '../../shared/models/model';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-news-listing',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './news-listing.component.html',
  styleUrl: './news-listing.component.scss',
})
export class NewslistingComponent implements OnInit, OnDestroy {
  public newsData: any;
  errorMessage: string = '';
  newsSubscription: Subscription = new Subscription();
  constructor(
    private _getNews: WidgetsService,
    private _router: Router,
  ) {}
  ngOnInit(): void {
    document.title = 'TruStage | News';
    const payLoad: requestPayload = {
      requestingSystem: 'FinPro',
    }; // Define your request payload here once
    this.newsSubscription = this._getNews.fetchNews(payLoad)?.subscribe({
      next: (response: any) => {
        this.newsData = response.newsList;
      },
      error: (error) => {
        this.errorMessage = error;
      },
    });
  }
  routeToNewsDetails(id: string, name: string) {
    //routing to news detail page
    this._router.navigate([`/advisor/news/${name.replaceAll(' ', '-')}`], {
      state: { obj: id },
    });
  }
  ngOnDestroy(): void {
    this.newsSubscription.unsubscribe();
  }
}
